<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} SITE</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <!-- NAME -->
        <vs-input label="Name *" v-if="this.dataId === null" v-model="dataName" class="mt-5 w-full" name="name" v-validate="'required'" />
        <span class="text-danger text-sm" v-if="this.dataId === null"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
         
        <vs-input label="URL *" placeholder="https://example.com/" v-model="dataUrl" class="mt-5 w-full" name="URL" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('URL')">{{ errors.first('URL') }}</span>

         <vs-input label="FTP Host *"  placeholder="ftp.example.com" v-model="dataFtp" class="mt-5 w-full" name="host" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('host')">{{ errors.first('host') }}</span>
        
        <vs-input label="Port *"  placeholder="22" v-model="dataPort" class="mt-5 w-full" name="port" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('port')">{{ errors.first('port') }}</span>
        
        <vs-input label="Home Folder *" placeholder="data/www/mysite" v-model="dataPath" class="mt-5 w-full" name="path" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('path')">{{ errors.first('path') }}</span>
        <span class="text-grey text-sm" >folder that contains your homepage.</span>
 

         <vs-input label="Username *" v-model="dataUsername" class="mt-5 w-full" name="username" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first('username') }}</span>
        <br>
         <label class="vs-input--label">Password *</label>
          <vx-input-group >
                  <template slot="append">
                    <div class="append-text cursor-pointer" style="color:#B0AFB7;background-color:white;border:1px solid rgba(0, 0, 0, 0.2); border-left:none">
                      <span @click="showPassword = !showPassword">
                              <feather-icon v-if="showPassword" icon="EyeOffIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                              <feather-icon v-else icon="EyeIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                        </span>
                    </div>
                  </template>

                  <vs-input 
                  ref="password"
                  v-model="dataPassword" 
                   data-vv-validate-on="blur"
                   v-validate="'required'"
                    v-bind:type="[showPassword ? 'text' : 'password']" 
                    name="password"
                    class="w-full no-right-border "
                  />
                </vx-input-group>
                <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
      
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { SAVE_NEW_WEBPAGE , SAVE_NEW_SITE , UPDATE_NEW_SITE } from "@/graphql";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      dataId:null,
      showPassword:false,
      dataName:null,
      dataUrl:null,
      dataFtp:null,
      dataPath:null,
      dataPort:null,
      dataUsername:null,
      dataPassword:null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id,name,host,url,username,password,port,path } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataName = name
        this.dataUrl = url
        this.dataFtp = host
        this.dataPath = path
        this.dataUsername = username
        this.dataPassword = password
        this.dataPort = port
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName && this.dataUrl && this.dataFtp && this.dataPath && this.dataUsername && this.dataPassword 
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    alertNofity (color,text) {
      this.$vs.notify({
        color: color,
        title: "Page",
        position: 'top-right',
        text: text
      })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = null
      this.dataUrl = null
      this.dataFtp = null
      this.dataPath = null
      this.dataUsername = null
      this.dataPassword = null
       this.dataPort = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
             this.$apollo
                .mutate({
                mutation: UPDATE_NEW_SITE,
                variables: {
                    id:this.dataId,
                    name:this.dataName,
                    url:this.dataUrl,
                    ftp:this.dataFtp,
                    path:this.dataPath,
                    username:this.dataUsername,
                    password:this.dataPassword,
                    port:this.dataPort
                }
                })
                .then(response => {
                    if(response.data.updateNewSite.status==='Success'){
                           this.$emit('closeSidebar')
                            this.initValues()
                             this.$emit('getdata')
                            this.alertNofity(response.data.updateNewSite.color,response.data.updateNewSite.message)
                    }
                    else{
                         this.alertNofity(response.data.updateNewSite.color,response.data.updateNewSite.message)

                    }
                }).catch(error => {
                console.log(error)
                })
          } else {

               this.$apollo
                .mutate({
                mutation: SAVE_NEW_SITE,
                variables: {
                    name:this.dataName,
                    url:this.dataUrl,
                    ftp:this.dataFtp,
                    path:this.dataPath,
                    username:this.dataUsername,
                    password:this.dataPassword,
                    port:this.dataPort
                }
                })
                .then(response => {
                    if(response.data.saveNewSite.status==='Success'){
                           this.$emit('closeSidebar')
                            this.initValues()
                             this.$emit('getdata')
                            this.alertNofity(response.data.saveNewSite.color,response.data.saveNewSite.message)
                    }
                    else{
                         this.alertNofity(response.data.saveNewSite.color,response.data.saveNewSite.message)

                    }
                }).catch(error => {
                console.log(error)
                })


          }


        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
